import * as React from 'react';
import { PerformanceDatapoint } from 'owa-analytics';
import { default as useAssetType } from './useAssetType';
import { useAssetId } from './useAssetId';

export default function useAssetPerfDatapoint() {
    const { current: assetPerfDatapoint } = React.useRef<PerformanceDatapoint>(
        new PerformanceDatapoint('boardAssetPerf')
    );

    const assetId = useAssetId();
    const assetType = useAssetType(assetId);

    React.useEffect(() => {
        assetPerfDatapoint.addCustomProperty('assetType', assetType);
    }, []);
    return assetPerfDatapoint;
}
